import React from "react";
import HeroItemSkeleton from "@src/components/Carousel/HeroItemSkeleton";
import TiktokSliderSkeleton from "./TiktokSliderSkeleton";
import VideoPlaySkeleton from "./VideoPlaySkeleton";
import EmojiSectionSkeleton from "./EmojiSectionSkeleton";
import EpisodeSectionSkeleton from "./EpisodeSectionSkeleton";
import MusicSectionSkeleton from "./MusicSectionSkeleton";
import NewsSectionSkeleton from "./NewsSectionSkeleton";

const HomeSkeleton: React.FC = () => {
  return (
    <div>
      {/* hero slider skeleton */}
      <HeroItemSkeleton />

      {/* tiktok slider section */}
      <TiktokSliderSkeleton />

      {/* video play section */}
      <VideoPlaySkeleton />

      {/* emoji section slider */}
      <EmojiSectionSkeleton />

      {/* episode section skeleton */}
      <EpisodeSectionSkeleton />

      {/* music section skeleton */}
      <MusicSectionSkeleton />

      {/* Fastu Chanel section */}
      <section className="py-14 radial-gradient-pink-bg w-full max-md:py-10 max-sm:py-6">
        <div className="container mx-auto flex max-md:flex-col items-center max-sm:items-center justify-center gap-16 max-md:gap-5 max-md:px-4">
          <div className="w-1/5 flex items-center justify-center max-sm:w-1/2 mx-auto">
            <span className="block w-[315px] h-[200px] bg-gray-300 skeleton rounded-3xl"></span>
          </div>
          <div className="max-sm:text-center flex flex-col gap-3">
            <div className=" flex items-center gap-3">
              <span className="block w-[73px] max-sm:w-14 h-12 bg-gray-300 skeleton rounded-xl"></span>
              <div className="flex items-center gap-2">
                <span className="flex-shrink-0 bg-gray-300 w-[400px] max-sm:w-[250px] h-9 rounded block"></span>
              </div>
            </div>
            <span className="w-[520px] max-sm:w-[300px] h-10 bg-gray-300 skeleton block rounded"></span>
            <span className="w-[350px] max-sm:w-[270px] h-10 bg-gray-300 skeleton block rounded"></span>
            <span className="w-[143px] h-[53px] bg-gray-300 skeleton block rounded-full"></span>
          </div>
        </div>
      </section>

      {/* fatsu news section */}
      <NewsSectionSkeleton />

      {/* subscribe section */}
      <section className="py-24 max-md:py-10 max-sm:py-6 bg-cover bg-no-repeat bg-[url('@assets/images/SubscribeBackground.webp')]">
        <div className="container mx-auto grid grid-cols-2 max-md:grid-cols-1 max-md:px-4 gap-8">
          <div className="flex items-start gap-5 justify-center flex-col">
            <span className="block w-[445px] max-sm:w-[280px] h-10 bg-gray-300 rounded skeleton"></span>
            <span className="block w-[495px] max-sm:w-[300px] h-[88px] bg-gray-300 rounded-2xl skeleton"></span>
            <div className="flex items-center gap-2">
              <span className="bg-gray-300 rounded skeleton w-6 h-6"></span>
              <span className="bg-gray-300 block w-[624px] max-sm:w-[300px] h-6 rounded skeleton"></span>
            </div>
          </div>
          <span className="block w-80 h-[504px] bg-gray-300 rounded skeleton mxq-auto"></span>
        </div>
      </section>
    </div>
  );
};

export default HomeSkeleton;
